<div class="details-page">
<div class="container details-shell">
    @if (task) {
        <div class="details-layout">

            <section class="task-intro details-card">
                <div class="title-row">
                    <a (click)="navigateBack()" class="icon-button" [attr.aria-label]="'DETAILS.BACK' | translate">
                        <img alt="" src="assets/images/month/left.svg">
                    </a>
                    <h1>{{ task.header }}</h1>
                    <button #filterBtnRef (click)="openFilterDialog()" class="icon-button" type="button" [attr.aria-label]="'DETAILS.FILTER' | translate">
                        <img alt="" src="assets/images/details/filter.svg">
                    </button>
                </div>

                <p [innerHTML]="task.description" class="detail"></p>
            </section>

            <section class="today-section details-card">
                <div class="section-heading">
                    <h2>{{ 'DETAILS.NEXT_OCCASIONS' | translate }}</h2>
                </div>

                @if (todayOccasion) {
                    <a [routerLink]="language.route('/day/' + formatDateForRouter(todayOccasion.date))" class="occasion occasion-today-link">
                            <mat-card [ngClass]="{
            'occasion-good': todayOccasion.weight === 'good',
            'occasion-best' : todayOccasion.weight === 'best',
            'occasion-bad' : todayOccasion.weight === 'bad',
            'occasion-worst' : todayOccasion.weight === 'worst' }" class="details occasion-card today-card">
                                <mat-card-content>
                                    <p class="today-label">{{ 'DETAILS.TODAY' | translate }}</p>
                                    <div class="date font-bold">
                                        {{ todayOccasion.date | dateWeekdayShort }}
                                    </div>
                                    <div class="occasion-phase">
                                        <span>{{ "PHASE." + todayOccasion.phase | translate }}</span>
                                        <span>{{ "SIGN." + todayOccasion.signId.toUpperCase() | translate }}</span>
                                    </div>
                                    <div class="occasion-weight">
                                        <span [ngClass]="'weight-' + todayOccasion.weight" class="">
                                            {{ 'WEIGHT.' + todayOccasion.weight.toUpperCase() | translate }}
                                        </span>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                    </a>
                }
                
                @if (!todayOccasion) {
                    <div class="occasion">
                        <mat-card class="details occasion-neutral occasion-card today-card">
                            <mat-card-content>
                                    <p class="today-label">{{ 'DETAILS.TODAY' | translate }}</p>
                                    <div class="date font-bold">
                                        {{ currentDay | dateWeekdayShort }}
                                </div>
                                @if (dayInformation) {
                                    <div class="occasion-phase">
                                        <span>{{ "PHASE." + dayInformation.phase | translate }}</span>
                                        <span>{{ "SIGN." + dayInformation.sign.id.toUpperCase() | translate }}</span>
                                    </div>
                                }
                                <div class="occasion-weight">
                                      <span [ngClass]="'weight-neutral'">
                                          {{ 'WEIGHT.NEUTRAL' | translate }}
                                      </span>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                }
            </section>


            <section class="upcoming-section details-card">
                <div class="section-heading compact">
                    <h2>{{ 'DETAILS.UPCOMING' | translate:{date: currentDay | date} }}</h2>
                </div>

            <div class="occasions-grid">
                @for (occasion of occasions; track occasion) {
                    <a [routerLink]="language.route('/day/' + formatDateForRouter(occasion.date))" class="occasion">
                            <mat-card [ngClass]="{
            'occasion-good': occasion.weight === 'good',
            'occasion-best' : occasion.weight === 'best',
            'occasion-bad' : occasion.weight === 'bad',
            'occasion-worst' : occasion.weight === 'worst' }" class="details occasion-card">
                                <mat-card-content>
                                    <div class="date font-bold">
                                        {{ occasion.date | dateWeekdayShort }}
                                    </div>
                                    <div class="occasion-phase">
                                        <span>{{ "PHASE." + occasion.phase | translate }}</span>
                                        <span>{{ "SIGN." + occasion.signId.toUpperCase() | translate }}</span>
                                    </div>
                                    <div class="occasion-weight">
                      <span [ngClass]="'weight-' + occasion.weight"
                            class="occasion-span">{{
                              'WEIGHT.' + occasion.weight.toUpperCase() | translate
                          }}</span></div>
                                </mat-card-content>
                            </mat-card>
                    </a>
                }
            </div>
            </section>
        </div>
    }
</div>
</div>
